import AD from '@resources/svgs/flags/AD.svg';
import AE from '@resources/svgs/flags/AE.svg';
import AF from '@resources/svgs/flags/AF.svg';
import AG from '@resources/svgs/flags/AG.svg';
import AI from '@resources/svgs/flags/AI.svg';
import AL from '@resources/svgs/flags/AL.svg';
import AM from '@resources/svgs/flags/AM.svg';
import AO from '@resources/svgs/flags/AO.svg';
import AR from '@resources/svgs/flags/AR.svg';
import AS from '@resources/svgs/flags/AS.svg';
import AT from '@resources/svgs/flags/AT.svg';
import AU from '@resources/svgs/flags/AU.svg';
import AW from '@resources/svgs/flags/AW.svg';
import AX from '@resources/svgs/flags/AX.svg';
import AZ from '@resources/svgs/flags/AZ.svg';
import BA from '@resources/svgs/flags/BA.svg';
import BB from '@resources/svgs/flags/BB.svg';
import BD from '@resources/svgs/flags/BD.svg';
import BE from '@resources/svgs/flags/BE.svg';
import BF from '@resources/svgs/flags/BF.svg';
import BG from '@resources/svgs/flags/BG.svg';
import BH from '@resources/svgs/flags/BH.svg';
import BI from '@resources/svgs/flags/BI.svg';
import BJ from '@resources/svgs/flags/BJ.svg';
import BM from '@resources/svgs/flags/BM.svg';
import BN from '@resources/svgs/flags/BN.svg';
import BO from '@resources/svgs/flags/BO.svg';
import BR from '@resources/svgs/flags/BR.svg';
import BS from '@resources/svgs/flags/BS.svg';
import BT from '@resources/svgs/flags/BT.svg';
import BW from '@resources/svgs/flags/BW.svg';
import BY from '@resources/svgs/flags/BY.svg';
import BZ from '@resources/svgs/flags/BZ.svg';
import CA from '@resources/svgs/flags/CA.svg';
import CC from '@resources/svgs/flags/CC.svg';
import CD from '@resources/svgs/flags/CD.svg';
import CF from '@resources/svgs/flags/CF.svg';
import CG from '@resources/svgs/flags/CG.svg';
import CH from '@resources/svgs/flags/CH.svg';
import CI from '@resources/svgs/flags/CI.svg';
import CK from '@resources/svgs/flags/CK.svg';
import CL from '@resources/svgs/flags/CL.svg';
import CM from '@resources/svgs/flags/CM.svg';
import CN from '@resources/svgs/flags/CN.svg';
import CO from '@resources/svgs/flags/CO.svg';
import CR from '@resources/svgs/flags/CR.svg';
import CU from '@resources/svgs/flags/CU.svg';
import CV from '@resources/svgs/flags/CV.svg';
import CX from '@resources/svgs/flags/CX.svg';
import CY from '@resources/svgs/flags/CY.svg';
import CZ from '@resources/svgs/flags/CZ.svg';
import DE from '@resources/svgs/flags/DE.svg';
import DJ from '@resources/svgs/flags/DJ.svg';
import DK from '@resources/svgs/flags/DK.svg';
import DM from '@resources/svgs/flags/DM.svg';
import DO from '@resources/svgs/flags/DO.svg';
import DZ from '@resources/svgs/flags/DZ.svg';
import EC from '@resources/svgs/flags/EC.svg';
import EE from '@resources/svgs/flags/EE.svg';
import EG from '@resources/svgs/flags/EG.svg';
import ER from '@resources/svgs/flags/ER.svg';
import ES from '@resources/svgs/flags/ES.svg';
import ET from '@resources/svgs/flags/ET.svg';
import FI from '@resources/svgs/flags/FI.svg';
import FJ from '@resources/svgs/flags/FJ.svg';
import FK from '@resources/svgs/flags/FK.svg';
import FM from '@resources/svgs/flags/FM.svg';
import FO from '@resources/svgs/flags/FO.svg';
import FR from '@resources/svgs/flags/FR.svg';
import GA from '@resources/svgs/flags/GA.svg';
import GB from '@resources/svgs/flags/GB.svg';
import GD from '@resources/svgs/flags/GD.svg';
import GE from '@resources/svgs/flags/GE.svg';
import GG from '@resources/svgs/flags/GG.svg';
import GH from '@resources/svgs/flags/GH.svg';
import GI from '@resources/svgs/flags/GI.svg';
import GL from '@resources/svgs/flags/GL.svg';
import GM from '@resources/svgs/flags/GM.svg';
import GN from '@resources/svgs/flags/GN.svg';
import GQ from '@resources/svgs/flags/GQ.svg';
import GR from '@resources/svgs/flags/GR.svg';
import GT from '@resources/svgs/flags/GT.svg';
import GU from '@resources/svgs/flags/GU.svg';
import GW from '@resources/svgs/flags/GW.svg';
import HK from '@resources/svgs/flags/HK.svg';
import HN from '@resources/svgs/flags/HN.svg';
import HR from '@resources/svgs/flags/HR.svg';
import HT from '@resources/svgs/flags/HT.svg';
import HU from '@resources/svgs/flags/HU.svg';
import ID from '@resources/svgs/flags/ID.svg';
import IE from '@resources/svgs/flags/IE.svg';
import IL from '@resources/svgs/flags/IL.svg';
import IM from '@resources/svgs/flags/IM.svg';
import IN from '@resources/svgs/flags/IN.svg';
import IO from '@resources/svgs/flags/IO.svg';
import IQ from '@resources/svgs/flags/IQ.svg';
import IR from '@resources/svgs/flags/IR.svg';
import IS from '@resources/svgs/flags/IS.svg';
import IT from '@resources/svgs/flags/IT.svg';
import JE from '@resources/svgs/flags/JE.svg';
import JM from '@resources/svgs/flags/JM.svg';
import JO from '@resources/svgs/flags/JO.svg';
import JP from '@resources/svgs/flags/JP.svg';
import KE from '@resources/svgs/flags/KE.svg';
import KG from '@resources/svgs/flags/KG.svg';
import KH from '@resources/svgs/flags/KH.svg';
import KM from '@resources/svgs/flags/KM.svg';
import KN from '@resources/svgs/flags/KN.svg';
import KP from '@resources/svgs/flags/KP.svg';
import KR from '@resources/svgs/flags/KR.svg';
import KW from '@resources/svgs/flags/KW.svg';
import KY from '@resources/svgs/flags/KY.svg';
import KZ from '@resources/svgs/flags/KZ.svg';
import LA from '@resources/svgs/flags/LA.svg';
import LB from '@resources/svgs/flags/LB.svg';
import LC from '@resources/svgs/flags/LC.svg';
import LI from '@resources/svgs/flags/LI.svg';
import LK from '@resources/svgs/flags/LK.svg';
import LR from '@resources/svgs/flags/LR.svg';
import LS from '@resources/svgs/flags/LS.svg';
import LT from '@resources/svgs/flags/LT.svg';
import LU from '@resources/svgs/flags/LU.svg';
import LV from '@resources/svgs/flags/LV.svg';
import LY from '@resources/svgs/flags/LY.svg';
import MA from '@resources/svgs/flags/MA.svg';
import MC from '@resources/svgs/flags/MC.svg';
import MD from '@resources/svgs/flags/MD.svg';
import MG from '@resources/svgs/flags/MG.svg';
import MH from '@resources/svgs/flags/MH.svg';
import MK from '@resources/svgs/flags/MK.svg';
import ML from '@resources/svgs/flags/ML.svg';
import MM from '@resources/svgs/flags/MM.svg';
import MN from '@resources/svgs/flags/MN.svg';
import MO from '@resources/svgs/flags/MO.svg';
import MP from '@resources/svgs/flags/MP.svg';
import MQ from '@resources/svgs/flags/MQ.svg';
import MR from '@resources/svgs/flags/MR.svg';
import MS from '@resources/svgs/flags/MS.svg';
import MT from '@resources/svgs/flags/MT.svg';
import MU from '@resources/svgs/flags/MU.svg';
import MV from '@resources/svgs/flags/MV.svg';
import MW from '@resources/svgs/flags/MW.svg';
import MX from '@resources/svgs/flags/MX.svg';
import MY from '@resources/svgs/flags/MY.svg';
import MZ from '@resources/svgs/flags/MZ.svg';
import NA from '@resources/svgs/flags/NA.svg';
import NE from '@resources/svgs/flags/NE.svg';
import NF from '@resources/svgs/flags/NF.svg';
import NG from '@resources/svgs/flags/NG.svg';
import NI from '@resources/svgs/flags/NI.svg';
import NL from '@resources/svgs/flags/NL.svg';
import NO from '@resources/svgs/flags/NO.svg';
import NP from '@resources/svgs/flags/NP.svg';
import NR from '@resources/svgs/flags/NR.svg';
import NU from '@resources/svgs/flags/NU.svg';
import NZ from '@resources/svgs/flags/NZ.svg';
import OM from '@resources/svgs/flags/OM.svg';
import PA from '@resources/svgs/flags/PA.svg';
import PE from '@resources/svgs/flags/PE.svg';
import PF from '@resources/svgs/flags/PF.svg';
import PG from '@resources/svgs/flags/PG.svg';
import PH from '@resources/svgs/flags/PH.svg';
import PK from '@resources/svgs/flags/PK.svg';
import PL from '@resources/svgs/flags/PL.svg';
import PN from '@resources/svgs/flags/PN.svg';
import PR from '@resources/svgs/flags/PR.svg';
import PS from '@resources/svgs/flags/PS.svg';
import PT from '@resources/svgs/flags/PT.svg';
import PW from '@resources/svgs/flags/PW.svg';
import PY from '@resources/svgs/flags/PY.svg';
import QA from '@resources/svgs/flags/QA.svg';
import RO from '@resources/svgs/flags/RO.svg';
import RU from '@resources/svgs/flags/RU.svg';
import RW from '@resources/svgs/flags/RW.svg';
import SA from '@resources/svgs/flags/SA.svg';
import SB from '@resources/svgs/flags/SB.svg';
import SC from '@resources/svgs/flags/SC.svg';
import SD from '@resources/svgs/flags/SD.svg';
import SE from '@resources/svgs/flags/SE.svg';
import SG from '@resources/svgs/flags/SG.svg';
import SI from '@resources/svgs/flags/SI.svg';
import SK from '@resources/svgs/flags/SK.svg';
import SL from '@resources/svgs/flags/SL.svg';
import SM from '@resources/svgs/flags/SM.svg';
import SN from '@resources/svgs/flags/SN.svg';
import SO from '@resources/svgs/flags/SO.svg';
import SR from '@resources/svgs/flags/SR.svg';
import ST from '@resources/svgs/flags/ST.svg';
import SV from '@resources/svgs/flags/SV.svg';
import SY from '@resources/svgs/flags/SY.svg';
import TC from '@resources/svgs/flags/TC.svg';
import TD from '@resources/svgs/flags/TD.svg';
import TG from '@resources/svgs/flags/TG.svg';
import TH from '@resources/svgs/flags/TH.svg';
import TJ from '@resources/svgs/flags/TJ.svg';
import TK from '@resources/svgs/flags/TK.svg';
import TL from '@resources/svgs/flags/TL.svg';
import TM from '@resources/svgs/flags/TM.svg';
import TN from '@resources/svgs/flags/TN.svg';
import TO from '@resources/svgs/flags/TO.svg';
import TR from '@resources/svgs/flags/TR.svg';
import TT from '@resources/svgs/flags/TT.svg';
import TW from '@resources/svgs/flags/TW.svg';
import TZ from '@resources/svgs/flags/TZ.svg';
import UA from '@resources/svgs/flags/UA.svg';
import UG from '@resources/svgs/flags/UG.svg';
import US from '@resources/svgs/flags/US.svg';
import UY from '@resources/svgs/flags/UY.svg';
import UZ from '@resources/svgs/flags/UZ.svg';
import VC from '@resources/svgs/flags/VC.svg';
import VE from '@resources/svgs/flags/VE.svg';
import VG from '@resources/svgs/flags/VG.svg';
import VI from '@resources/svgs/flags/VI.svg';
import VN from '@resources/svgs/flags/VN.svg';
import VU from '@resources/svgs/flags/VU.svg';
import WS from '@resources/svgs/flags/WS.svg';
import YE from '@resources/svgs/flags/YE.svg';
import ZA from '@resources/svgs/flags/ZA.svg';
import ZM from '@resources/svgs/flags/ZM.svg';
import ZW from '@resources/svgs/flags/ZW.svg';

/**
 * Country info.
 * Ordered alphabetically by country name, not key. It is used in order to populate lists. If this order needs to change you will need to update the ordering of countries.
 */
export const countryInfo = {
  AF: {
    name: 'Afghanistan',
    code: 'AF',
    flag: AF,
  },
  AX: {
    name: 'Åland Islands',
    code: 'AX',
    flag: AX,
  },
  AL: {
    name: 'Albania',
    code: 'AL',
    flag: AL,
  },
  DZ: {
    name: 'Algeria',
    code: 'DZ',
    flag: DZ,
  },
  AS: {
    name: 'American Samoa',
    code: 'AS',
    flag: AS,
  },
  AD: {
    name: 'AndorrA',
    code: 'AD',
    flag: AD,
  },
  AO: {
    name: 'Angola',
    code: 'AO',
    flag: AO,
  },
  AI: {
    name: 'Anguilla',
    code: 'AI',
    flag: AI,
  },
  AG: {
    name: 'Antigua and Barbuda',
    code: 'AG',
    flag: AG,
  },
  AR: {
    name: 'Argentina',
    code: 'AR',
    flag: AR,
  },
  AM: {
    name: 'Armenia',
    code: 'AM',
    flag: AM,
  },
  AW: {
    name: 'Aruba',
    code: 'AW',
    flag: AW,
  },
  AU: {
    name: 'Australia',
    code: 'AU',
    flag: AU,
  },
  AT: {
    name: 'Austria',
    code: 'AT',
    flag: AT,
  },
  AZ: {
    name: 'Azerbaijan',
    code: 'AZ',
    flag: AZ,
  },
  BS: {
    name: 'Bahamas',
    code: 'BS',
    flag: BS,
  },
  BH: {
    name: 'Bahrain',
    code: 'BH',
    flag: BH,
  },
  BD: {
    name: 'Bangladesh',
    code: 'BD',
    flag: BD,
  },
  BB: {
    name: 'Barbados',
    code: 'BB',
    flag: BB,
  },
  BY: {
    name: 'Belarus',
    code: 'BY',
    flag: BY,
  },
  BE: {
    name: 'Belgium',
    code: 'BE',
    flag: BE,
  },
  BZ: {
    name: 'Belize',
    code: 'BZ',
    flag: BZ,
  },
  BJ: {
    name: 'Benin',
    code: 'BJ',
    flag: BJ,
  },
  BM: {
    name: 'Bermuda',
    code: 'BM',
    flag: BM,
  },
  BT: {
    name: 'Bhutan',
    code: 'BT',
    flag: BT,
  },
  BO: {
    name: 'Bolivia',
    code: 'BO',
    flag: BO,
  },
  BA: {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
    flag: BA,
  },
  BW: {
    name: 'Botswana',
    code: 'BW',
    flag: BW,
  },
  BR: {
    name: 'Brazil',
    code: 'BR',
    flag: BR,
  },
  IO: {
    name: 'British Indian Ocean Territory',
    code: 'IO',
    flag: IO,
  },
  BN: {
    name: 'Brunei Darussalam',
    code: 'BN',
    flag: BN,
  },
  BG: {
    name: 'Bulgaria',
    code: 'BG',
    flag: BG,
  },
  BF: {
    name: 'Burkina Faso',
    code: 'BF',
    flag: BF,
  },
  BI: {
    name: 'Burundi',
    code: 'BI',
    flag: BI,
  },
  KH: {
    name: 'Cambodia',
    code: 'KH',
    flag: KH,
  },
  CM: {
    name: 'Cameroon',
    code: 'CM',
    flag: CM,
  },
  CA: {
    name: 'Canada',
    code: 'CA',
    flag: CA,
  },
  CS: {
    name: 'Canada (Saskatchewan)',
    code: 'CS',
    flag: CA,
  },
  NB: {
    name: 'Canada (New Brunswick)',
    code: 'NB',
    flag: CA,
  },
  NS: {
    name: 'Canada (Nova Scotia)',
    code: 'NS',
    flag: CA,
  },
  NT: {
    name: 'Canada (Northwest Territories)',
    code: 'NT',
    flag: CA,
  },
  BC: {
    name: 'Canada (British Columbia)',
    code: 'BC',
    flag: CA,
  },
  QC: {
    name: 'Canada (Quebec)',
    code: 'QC',
    flag: CA,
  },
  AB: {
    name: 'Canada (Alberta)',
    code: 'AB',
    flag: CA,
  },
  ON: {
    name: 'Canada (Ontario)',
    code: 'ON',
    flag: CA,
  },
  MB: {
    name: 'Canada (Manitoba)',
    code: 'MB',
    flag: CA,
  },
  CV: {
    name: 'Cape Verde',
    code: 'CV',
    flag: CV,
  },
  KY: {
    name: 'Cayman Islands',
    code: 'KY',
    flag: KY,
  },
  CF: {
    name: 'Central African Republic',
    code: 'CF',
    flag: CF,
  },
  TD: {
    name: 'Chad',
    code: 'TD',
    flag: TD,
  },
  CL: {
    name: 'Chile',
    code: 'CL',
    flag: CL,
  },
  CN: {
    name: 'China',
    code: 'CN',
    flag: CN,
  },
  CX: {
    name: 'Christmas Island',
    code: 'CX',
    flag: CX,
  },
  CC: {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
    flag: CC,
  },
  CO: {
    name: 'Colombia',
    code: 'CO',
    flag: CO,
  },
  KM: {
    name: 'Comoros',
    code: 'KM',
    flag: KM,
  },
  CG: {
    name: 'Congo',
    code: 'CG',
    flag: CG,
  },
  CD: {
    name: 'Congo, The Democratic Republic of the',
    code: 'CD',
    flag: CD,
  },
  CK: {
    name: 'Cook Islands',
    code: 'CK',
    flag: CK,
  },
  CR: {
    name: 'Costa Rica',
    code: 'CR',
    flag: CR,
  },
  CI: {
    name: "Cote D'Ivoire",
    code: 'CI',
    flag: CI,
  },
  HR: {
    name: 'Croatia',
    code: 'HR',
    flag: HR,
  },
  CU: {
    name: 'Cuba',
    code: 'CU',
    flag: CU,
  },
  CY: {
    name: 'Cyprus',
    code: 'CY',
    flag: CY,
  },
  CZ: {
    name: 'Czech Republic',
    code: 'CZ',
    flag: CZ,
  },
  DK: {
    name: 'Denmark',
    code: 'DK',
    flag: DK,
  },
  DJ: {
    name: 'Djibouti',
    code: 'DJ',
    flag: DJ,
  },
  DM: {
    name: 'Dominica',
    code: 'DM',
    flag: DM,
  },
  DO: {
    name: 'Dominican Republic',
    code: 'DO',
    flag: DO,
  },
  EC: {
    name: 'Ecuador',
    code: 'EC',
    flag: EC,
  },
  EG: {
    name: 'Egypt',
    code: 'EG',
    flag: EG,
  },
  SV: {
    name: 'El Salvador',
    code: 'SV',
    flag: SV,
  },
  GQ: {
    name: 'Equatorial Guinea',
    code: 'GQ',
    flag: GQ,
  },
  ER: {
    name: 'Eritrea',
    code: 'ER',
    flag: ER,
  },
  EE: {
    name: 'Estonia',
    code: 'EE',
    flag: EE,
  },
  ET: {
    name: 'Ethiopia',
    code: 'ET',
    flag: ET,
  },
  FK: {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
    flag: FK,
  },
  FO: {
    name: 'Faroe Islands',
    code: 'FO',
    flag: FO,
  },
  FJ: {
    name: 'Fiji',
    code: 'FJ',
    flag: FJ,
  },
  FI: {
    name: 'Finland',
    code: 'FI',
    flag: FI,
  },
  FR: {
    name: 'France',
    code: 'FR',
    flag: FR,
  },
  // GF: {
  //   name: 'French Guiana',
  //   code: 'GF',
  //   flag: GF
  // },
  PF: {
    name: 'French Polynesia',
    code: 'PF',
    flag: PF,
  },
  GA: {
    name: 'Gabon',
    code: 'GA',
    flag: GA,
  },
  GM: {
    name: 'Gambia',
    code: 'GM',
    flag: GM,
  },
  GE: {
    name: 'Georgia',
    code: 'GE',
    flag: GE,
  },
  DE: {
    name: 'Germany',
    code: 'DE',
    flag: DE,
  },
  GH: {
    name: 'Ghana',
    code: 'GH',
    flag: GH,
  },
  GI: {
    name: 'Gibraltar',
    code: 'GI',
    flag: GI,
  },
  GR: {
    name: 'Greece',
    code: 'GR',
    flag: GR,
  },
  GL: {
    name: 'Greenland',
    code: 'GL',
    flag: GL,
  },
  GD: {
    name: 'Grenada',
    code: 'GD',
    flag: GD,
  },
  GU: {
    name: 'Guam',
    code: 'GU',
    flag: GU,
  },
  GT: {
    name: 'Guatemala',
    code: 'GT',
    flag: GT,
  },
  GG: {
    name: 'Guernsey',
    code: 'GG',
    flag: GG,
  },
  GN: {
    name: 'Guinea',
    code: 'GN',
    flag: GN,
  },
  GW: {
    name: 'Guinea-Bissau',
    code: 'GW',
    flag: GW,
  },
  HT: {
    name: 'Haiti',
    code: 'HT',
    flag: HT,
  },
  HN: {
    name: 'Honduras',
    code: 'HN',
    flag: HN,
  },
  HK: {
    name: 'Hong Kong',
    code: 'HK',
    flag: HK,
  },
  HU: {
    name: 'Hungary',
    code: 'HU',
    flag: HU,
  },
  IS: {
    name: 'Iceland',
    code: 'IS',
    flag: IS,
  },
  IN: {
    name: 'India',
    code: 'IN',
    flag: IN,
  },
  ID: {
    name: 'Indonesia',
    code: 'ID',
    flag: ID,
  },
  IR: {
    name: 'Iran, Islamic Republic Of',
    code: 'IR',
    flag: IR,
  },
  IQ: {
    name: 'Iraq',
    code: 'IQ',
    flag: IQ,
  },
  IE: {
    name: 'Ireland',
    code: 'IE',
    flag: IE,
  },
  IM: {
    name: 'Isle of Man',
    code: 'IM',
    flag: IM,
  },
  IL: {
    name: 'Israel',
    code: 'IL',
    flag: IL,
  },
  IT: {
    name: 'Italy',
    code: 'IT',
    flag: IT,
  },
  JM: {
    name: 'Jamaica',
    code: 'JM',
    flag: JM,
  },
  JP: {
    name: 'Japan',
    code: 'JP',
    flag: JP,
  },
  JE: {
    name: 'Jersey',
    code: 'JE',
    flag: JE,
  },
  JO: {
    name: 'Jordan',
    code: 'JO',
    flag: JO,
  },
  KZ: {
    name: 'Kazakhstan',
    code: 'KZ',
    flag: KZ,
  },
  KE: {
    name: 'Kenya',
    code: 'KE',
    flag: KE,
  },
  KP: {
    name: "Korea, People's Democratic Republic",
    code: 'KP',
    flag: KP,
  },
  KR: {
    name: 'Korea, Republic of',
    code: 'KR',
    flag: KR,
  },
  KW: {
    name: 'Kuwait',
    code: 'KW',
    flag: KW,
  },
  KG: {
    name: 'Kyrgyzstan',
    code: 'KG',
    flag: KG,
  },
  LA: {
    name: "Lao People'S Democratic Republic",
    code: 'LA',
    flag: LA,
  },
  LV: {
    name: 'Latvia',
    code: 'LV',
    flag: LV,
  },
  LB: {
    name: 'Lebanon',
    code: 'LB',
    flag: LB,
  },
  LS: {
    name: 'Lesotho',
    code: 'LS',
    flag: LS,
  },
  LR: {
    name: 'Liberia',
    code: 'LR',
    flag: LR,
  },
  LY: {
    name: 'Libyan Arab Jamahiriya',
    code: 'LY',
    flag: LY,
  },
  LI: {
    name: 'Liechtenstein',
    code: 'LI',
    flag: LI,
  },
  LT: {
    name: 'Lithuania',
    code: 'LT',
    flag: LT,
  },
  LU: {
    name: 'Luxembourg',
    code: 'LU',
    flag: LU,
  },
  MO: {
    name: 'Macao',
    code: 'MO',
    flag: MO,
  },
  MK: {
    name: 'Macedonia, The Former Yugoslav Republic of',
    code: 'MK',
    flag: MK,
  },
  MG: {
    name: 'Madagascar',
    code: 'MG',
    flag: MG,
  },
  MW: {
    name: 'Malawi',
    code: 'MW',
    flag: MW,
  },
  MY: {
    name: 'Malaysia',
    code: 'MY',
    flag: MY,
  },
  MV: {
    name: 'Maldives',
    code: 'MV',
    flag: MV,
  },
  ML: {
    name: 'Mali',
    code: 'ML',
    flag: ML,
  },
  MT: {
    name: 'Malta',
    code: 'MT',
    flag: MT,
  },
  MH: {
    name: 'Marshall Islands',
    code: 'MH',
    flag: MH,
  },
  MQ: {
    name: 'Martinique',
    code: 'MQ',
    flag: MQ,
  },
  MR: {
    name: 'Mauritania',
    code: 'MR',
    flag: MR,
  },
  MU: {
    name: 'Mauritius',
    code: 'MU',
    flag: MU,
  },
  MX: {
    name: 'Mexico',
    code: 'MX',
    flag: MX,
  },
  FM: {
    name: 'Micronesia, Federated States of',
    code: 'FM',
    flag: FM,
  },
  HM: {
    name: 'Heard Island and McDonald Islands',
    code: 'HM',
    flag: AU,
  },
  MD: {
    name: 'Moldova, Republic of',
    code: 'MD',
    flag: MD,
  },
  MC: {
    name: 'Monaco',
    code: 'MC',
    flag: MC,
  },
  MN: {
    name: 'Mongolia',
    code: 'MN',
    flag: MN,
  },
  MS: {
    name: 'Montserrat',
    code: 'MS',
    flag: MS,
  },
  MA: {
    name: 'Morocco',
    code: 'MA',
    flag: MA,
  },
  MZ: {
    name: 'Mozambique',
    code: 'MZ',
    flag: MZ,
  },
  MM: {
    name: 'Myanmar',
    code: 'MM',
    flag: MM,
  },
  NA: {
    name: 'Namibia',
    code: 'NA',
    flag: NA,
  },
  NR: {
    name: 'Nauru',
    code: 'NR',
    flag: NR,
  },
  NP: {
    name: 'Nepal',
    code: 'NP',
    flag: NP,
  },
  NL: {
    name: 'Netherlands',
    code: 'NL',
    flag: NL,
  },
  NZ: {
    name: 'New Zealand',
    code: 'NZ',
    flag: NZ,
  },
  NI: {
    name: 'Nicaragua',
    code: 'NI',
    flag: NI,
  },
  NE: {
    name: 'Niger',
    code: 'NE',
    flag: NE,
  },
  NG: {
    name: 'Nigeria',
    code: 'NG',
    flag: NG,
  },
  NU: {
    name: 'Niue',
    code: 'NU',
    flag: NU,
  },
  NF: {
    name: 'Norfolk Island',
    code: 'NF',
    flag: NF,
  },
  MP: {
    name: 'Northern Mariana Islands',
    code: 'MP',
    flag: MP,
  },
  NO: {
    name: 'Norway',
    code: 'NO',
    flag: NO,
  },
  OM: {
    name: 'Oman',
    code: 'OM',
    flag: OM,
  },
  PK: {
    name: 'Pakistan',
    code: 'PK',
    flag: PK,
  },
  PW: {
    name: 'Palau',
    code: 'PW',
    flag: PW,
  },
  PS: {
    name: 'Palestinian Territory, Occupied',
    code: 'PS',
    flag: PS,
  },
  PA: {
    name: 'Panama',
    code: 'PA',
    flag: PA,
  },
  PG: {
    name: 'Papua New Guinea',
    code: 'PG',
    flag: PG,
  },
  PY: {
    name: 'Paraguay',
    code: 'PY',
    flag: PY,
  },
  PE: {
    name: 'Peru',
    code: 'PE',
    flag: PE,
  },
  PH: {
    name: 'Philippines',
    code: 'PH',
    flag: PH,
  },
  PN: {
    name: 'Pitcairn',
    code: 'PN',
    flag: PN,
  },
  PL: {
    name: 'Poland',
    code: 'PL',
    flag: PL,
  },
  PT: {
    name: 'Portugal',
    code: 'PT',
    flag: PT,
  },
  PR: {
    name: 'Puerto Rico',
    code: 'PR',
    flag: PR,
  },
  QA: {
    name: 'Qatar',
    code: 'QA',
    flag: QA,
  },
  RO: {
    name: 'Romania',
    code: 'RO',
    flag: RO,
  },
  RU: {
    name: 'Russian Federation',
    code: 'RU',
    flag: RU,
  },
  RW: {
    name: 'RWANDA',
    code: 'RW',
    flag: RW,
  },
  KN: {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
    flag: KN,
  },
  LC: {
    name: 'Saint Lucia',
    code: 'LC',
    flag: LC,
  },
  VC: {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
    flag: VC,
  },
  WS: {
    name: 'Samoa',
    code: 'WS',
    flag: WS,
  },
  SM: {
    name: 'San Marino',
    code: 'SM',
    flag: SM,
  },
  ST: {
    name: 'Sao Tome and Principe',
    code: 'ST',
    flag: ST,
  },
  SA: {
    name: 'Saudi Arabia',
    code: 'SA',
    flag: SA,
  },
  SN: {
    name: 'Senegal',
    code: 'SN',
    flag: SN,
  },
  SC: {
    name: 'Seychelles',
    code: 'SC',
    flag: SC,
  },
  SL: {
    name: 'Sierra Leone',
    code: 'SL',
    flag: SL,
  },
  SG: {
    name: 'Singapore',
    code: 'SG',
    flag: SG,
  },
  SK: {
    name: 'Slovakia',
    code: 'SK',
    flag: SK,
  },
  SI: {
    name: 'Slovenia',
    code: 'SI',
    flag: SI,
  },
  SB: {
    name: 'Solomon Islands',
    code: 'SB',
    flag: SB,
  },
  SO: {
    name: 'Somalia',
    code: 'SO',
    flag: SO,
  },
  ZA: {
    name: 'South Africa',
    code: 'ZA',
    flag: ZA,
  },
  ES: {
    name: 'Spain',
    code: 'ES',
    flag: ES,
  },
  LK: {
    name: 'Sri Lanka',
    code: 'LK',
    flag: LK,
  },
  SD: {
    name: 'Sudan',
    code: 'SD',
    flag: SD,
  },
  SR: {
    name: 'Suriname',
    code: 'SR',
    flag: SR,
  },
  SE: {
    name: 'Sweden',
    code: 'SE',
    flag: SE,
  },
  CH: {
    name: 'Switzerland',
    code: 'CH',
    flag: CH,
  },
  SY: {
    name: 'Syrian Arab Republic',
    code: 'SY',
    flag: SY,
  },
  TW: {
    name: 'Taiwan',
    code: 'TW',
    flag: TW,
  },
  TJ: {
    name: 'Tajikistan',
    code: 'TJ',
    flag: TJ,
  },
  TZ: {
    name: 'Tanzania, United Republic of',
    code: 'TZ',
    flag: TZ,
  },
  TH: {
    name: 'Thailand',
    code: 'TH',
    flag: TH,
  },
  TL: {
    name: 'Timor-Leste',
    code: 'TL',
    flag: TL,
  },
  TG: {
    name: 'Togo',
    code: 'TG',
    flag: TG,
  },
  TK: {
    name: 'Tokelau',
    code: 'TK',
    flag: TK,
  },
  TO: {
    name: 'Tonga',
    code: 'TO',
    flag: TO,
  },
  TT: {
    name: 'Trinidad and Tobago',
    code: 'TT',
    flag: TT,
  },
  TN: {
    name: 'Tunisia',
    code: 'TN',
    flag: TN,
  },
  TR: {
    name: 'Turkey',
    code: 'TR',
    flag: TR,
  },
  TM: {
    name: 'Turkmenistan',
    code: 'TM',
    flag: TM,
  },
  TC: {
    name: 'Turks and Caicos Islands',
    code: 'TC',
    flag: TC,
  },
  UG: {
    name: 'Uganda',
    code: 'UG',
    flag: UG,
  },
  UA: {
    name: 'Ukraine',
    code: 'UA',
    flag: UA,
  },
  AE: {
    name: 'United Arab Emirates',
    code: 'AE',
    flag: AE,
  },
  GB: {
    name: 'United Kingdom',
    code: 'GB',
    flag: GB,
  },
  GC: {
    name: 'Channel Islands',
    code: 'GC',
    flag: GB,
  },
  US: {
    name: 'United States',
    code: 'US',
    flag: US,
  },
  UY: {
    name: 'Uruguay',
    code: 'UY',
    flag: UY,
  },
  UZ: {
    name: 'Uzbekistan',
    code: 'UZ',
    flag: UZ,
  },
  VU: {
    name: 'Vanuatu',
    code: 'VU',
    flag: VU,
  },
  VE: {
    name: 'Venezuela',
    code: 'VE',
    flag: VE,
  },
  VN: {
    name: 'Viet Nam',
    code: 'VN',
    flag: VN,
  },
  VG: {
    name: 'Virgin Islands, British',
    code: 'VG',
    flag: VG,
  },
  VI: {
    name: 'Virgin Islands, U.S.',
    code: 'VI',
    flag: VI,
  },
  WK: {
    name: 'Wake Island',
    code: 'WK',
    flag: US,
  },
  WF: {
    name: 'Wallis and Futuna',
    code: 'WF',
    flag: WS,
  },
  YE: {
    name: 'Yemen',
    code: 'YE',
    flag: YE,
  },
  ZM: {
    name: 'Zambia',
    code: 'ZM',
    flag: ZM,
  },
  ZW: {
    name: 'Zimbabwe',
    code: 'ZW',
    flag: ZW,
  },
} as const;

export const countries = Object.values(countryInfo);

export const COUNTRIES = {
  AF: 'AF',
  AX: 'AX',
  AL: 'AL',
  DZ: 'DZ',
  AS: 'AS',
  AD: 'AD',
  AO: 'AO',
  AI: 'AI',
  AG: 'AG',
  AR: 'AR',
  AM: 'AM',
  AW: 'AW',
  AU: 'AU',
  AT: 'AT',
  AZ: 'AZ',
  BS: 'BS',
  BH: 'BH',
  BD: 'BD',
  BB: 'BB',
  BY: 'BY',
  BE: 'BE',
  BZ: 'BZ',
  BJ: 'BJ',
  BM: 'BM',
  BT: 'BT',
  BO: 'BO',
  BA: 'BA',
  BW: 'BW',
  BR: 'BR',
  IO: 'IO',
  BN: 'BN',
  BG: 'BG',
  BF: 'BF',
  BI: 'BI',
  KH: 'KH',
  CM: 'CM',
  CA: 'CA',
  CS: 'CS',
  NB: 'NB',
  NS: 'NS',
  NT: 'NT',
  BC: 'BC',
  QC: 'QC',
  AB: 'AB',
  ON: 'ON',
  MB: 'MB',
  CV: 'CV',
  KY: 'KY',
  CF: 'CF',
  TD: 'TD',
  CL: 'CL',
  CN: 'CN',
  CX: 'CX',
  CC: 'CC',
  CO: 'CO',
  KM: 'KM',
  CG: 'CG',
  CD: 'CD',
  CK: 'CK',
  CR: 'CR',
  CI: 'CI',
  HR: 'HR',
  CU: 'CU',
  CY: 'CY',
  CZ: 'CZ',
  DK: 'DK',
  DJ: 'DJ',
  DM: 'DM',
  DO: 'DO',
  EC: 'EC',
  EG: 'EG',
  SV: 'SV',
  GQ: 'GQ',
  ER: 'ER',
  EE: 'EE',
  ET: 'ET',
  FK: 'FK',
  FO: 'FO',
  FJ: 'FJ',
  FI: 'FI',
  FR: 'FR',
  PF: 'PF',
  GA: 'GA',
  GM: 'GM',
  GE: 'GE',
  DE: 'DE',
  GH: 'GH',
  GI: 'GI',
  GR: 'GR',
  GL: 'GL',
  GD: 'GD',
  GU: 'GU',
  GT: 'GT',
  GG: 'GG',
  GC: 'GC',
  GN: 'GN',
  GW: 'GW',
  HT: 'HT',
  HN: 'HN',
  HK: 'HK',
  HU: 'HU',
  IS: 'IS',
  IN: 'IN',
  ID: 'ID',
  IR: 'IR',
  IQ: 'IQ',
  IE: 'IE',
  IM: 'IM',
  IL: 'IL',
  IT: 'IT',
  JM: 'JM',
  JP: 'JP',
  JE: 'JE',
  JO: 'JO',
  KZ: 'KZ',
  KE: 'KE',
  KP: 'KP',
  KR: 'KR',
  KW: 'KW',
  KG: 'KG',
  LA: 'LA',
  LV: 'LV',
  LB: 'LB',
  LS: 'LS',
  LR: 'LR',
  LY: 'LY',
  LI: 'LI',
  LT: 'LT',
  LU: 'LU',
  MO: 'MO',
  MK: 'MK',
  MG: 'MG',
  MW: 'MW',
  MY: 'MY',
  MV: 'MV',
  ML: 'ML',
  MT: 'MT',
  MH: 'MH',
  MQ: 'MQ',
  MR: 'MR',
  MU: 'MU',
  MX: 'MX',
  FM: 'FM',
  HM: 'HM',
  MD: 'MD',
  MC: 'MC',
  MN: 'MN',
  MS: 'MS',
  MA: 'MA',
  MZ: 'MZ',
  MM: 'MM',
  NA: 'NA',
  NR: 'NR',
  NP: 'NP',
  NL: 'NL',
  NZ: 'NZ',
  NI: 'NI',
  NE: 'NE',
  NG: 'NG',
  NU: 'NU',
  NF: 'NF',
  MP: 'MP',
  NO: 'NO',
  OM: 'OM',
  PK: 'PK',
  PW: 'PW',
  PS: 'PS',
  PA: 'PA',
  PG: 'PG',
  PY: 'PY',
  PE: 'PE',
  PH: 'PH',
  PN: 'PN',
  PL: 'PL',
  PT: 'PT',
  PR: 'PR',
  QA: 'QA',
  RO: 'RO',
  RU: 'RU',
  RW: 'RW',
  KN: 'KN',
  LC: 'LC',
  VC: 'VC',
  WS: 'WS',
  SM: 'SM',
  ST: 'ST',
  SA: 'SA',
  SN: 'SN',
  SC: 'SC',
  SL: 'SL',
  SG: 'SG',
  SK: 'SK',
  SI: 'SI',
  SB: 'SB',
  SO: 'SO',
  ZA: 'ZA',
  ES: 'ES',
  LK: 'LK',
  SD: 'SD',
  SR: 'SR',
  SE: 'SE',
  CH: 'CH',
  SY: 'SY',
  TW: 'TW',
  TJ: 'TJ',
  TZ: 'TZ',
  TH: 'TH',
  TL: 'TL',
  TG: 'TG',
  TK: 'TK',
  TO: 'TO',
  TT: 'TT',
  TN: 'TN',
  TR: 'TR',
  TM: 'TM',
  TC: 'TC',
  UG: 'UG',
  UA: 'UA',
  AE: 'AE',
  GB: 'GB',
  US: 'US',
  UY: 'UY',
  UZ: 'UZ',
  VU: 'VU',
  VE: 'VE',
  VN: 'VN',
  VG: 'VG',
  VI: 'VI',
  WK: 'WK',
  WF: 'WF',
  YE: 'YE',
  ZM: 'ZM',
  ZW: 'ZW',
} as const;
